import { getContactId, getToken} from "../tools/utils";

type IGenericObject = {
    [key: string]: any;
};

interface IRequestOptions {
    endpoint: string;
    signal?: AbortSignal;
    type?: 'json' | 'form' | 'data';
    data?: IGenericObject | FormData;
    method?: 'GET' | 'POST' | 'PUT' | 'PATCH' | 'DELETE';
    isPrivate?: boolean;
    headers?: IGenericObject;
}


export const request = async ({ endpoint, type = 'json', data, method = 'GET', signal, isPrivate = false, headers: customHeaders }: IRequestOptions) => {
    const { REACT_APP_WEB_API, REACT_APP_HEADERKEY } = process.env;
    var contactId = await getContactId()
    const tokenId = await getToken();
    const headers: IGenericObject = { ...customHeaders };
    if(!contactId){
        const activeAccountKey=JSON.parse(localStorage.getItem('msal.account.keys'));
        const activeAccount=JSON.parse(localStorage.getItem(activeAccountKey[0]));
        if(activeAccount){
        contactId=activeAccount.idTokenClaims.extension_ContactId;
        }
    }

    if (type) {
        switch (type) {
            case 'json':
                if ('GET' !== method) {
                    headers['Content-Type'] = 'application/json';
                }
                break;

            case 'data':
                if (data instanceof Blob) {
                    headers['Content-Type'] = 'application/octet-stream';
                }
                break;
        }
    }

    const separator = endpoint.includes('?') ? '&' : '?';
    const contactParam = isPrivate ? `isPrivate=${isPrivate}&contactId=${contactId}` : `contactId=${contactId}`;

    const response = await fetch(
        `${REACT_APP_WEB_API}${endpoint}${separator}${contactParam}${
            data && 'GET' === method && !(data instanceof FormData) ? `&${new URLSearchParams(data)}` : ''
        }`,
        {
            method,
            signal,
            body: data
                ? (data instanceof FormData || data instanceof Blob || data instanceof ArrayBuffer)
                    ? data
                    : 'GET' === method
                    ? undefined
                    : JSON.stringify(data)
                : undefined,
            headers: {
                ...headers,
                Accept: 'application/json',
                Authorization: `Bearer ${tokenId}`,
                "Access-Control-Allow-Origin": "*",
                "Head-Key":REACT_APP_HEADERKEY  
            },
            
        }
    );

    const success = response.ok;

    return {
        success,
        data: await response.json(),
    };
}